export class BaseModel {
  id: string = "";
  createdAt: number;
  updatedAt?: number;

  constructor(id?: string, createdAt?: number, updatedAt?: number) {
    this.id = id || "";
    this.createdAt = createdAt || Date.now();
    this.updatedAt = updatedAt;
  }
}

export class BaseModelActive {
  id: string = "";
  active: boolean = true;
  createdAt: number;
  updatedAt?: number;

  constructor(id?: string, active?: boolean, createdAt?: number, updatedAt?: number) {
    this.id = id || "";
    this.active = active ?? true;
    this.createdAt = createdAt || Date.now();
    this.updatedAt = updatedAt;
  }
}
